var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { parseGwei } from 'viem';
export var NATIVE_ADDRESS = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';
export var ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export var NATIVE_SOL = '11111111111111111111111111111111';
export var WRAPPED_SOL = 'So11111111111111111111111111111111111111112';
export var SUI_NATIVE_ADDRESS = '0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI';
export var ChainId;
(function (ChainId) {
    ChainId[ChainId["UNKNOWN"] = 0] = "UNKNOWN";
    ChainId[ChainId["BASE"] = 8453] = "BASE";
    ChainId[ChainId["SOLANA"] = 1399811149] = "SOLANA";
    ChainId[ChainId["SOLANA_DLN"] = 7565164] = "SOLANA_DLN";
    ChainId[ChainId["SOLANA_OKX"] = 501] = "SOLANA_OKX";
    ChainId[ChainId["ARBITRUM"] = 42161] = "ARBITRUM";
    ChainId[ChainId["OPTIMISM"] = 10] = "OPTIMISM";
    ChainId[ChainId["POLYGON"] = 137] = "POLYGON";
    ChainId[ChainId["BSC"] = 56] = "BSC";
    ChainId[ChainId["AVALANCHE"] = 43114] = "AVALANCHE";
    ChainId[ChainId["BLAST"] = 81457] = "BLAST";
    ChainId[ChainId["ETHEREUM"] = 1] = "ETHEREUM";
    ChainId[ChainId["SUI"] = 101] = "SUI";
})(ChainId || (ChainId = {}));
export var WhiteListedTargets = (_a = {},
    _a[ChainId.ETHEREUM] = [
        { address: '0x7D0CcAa3Fac1e5A943c5168b6CEd828691b46B36', protocol: 'OKX DEX router' },
        { address: '0x40aA958dd87FC8305b97f2BA922CDdCa374bcD7f', protocol: 'OKX Token approval' },
        { address: '0xCf5540fFFCdC3d510B18bFcA6d2b9987b0772559', protocol: 'Odos aggregator router' },
        {
            address: '0x6131B5fae19EA4f9D964eAc0408E4408b66337b5',
            protocol: 'Kyberswap aggregator router',
        },
    ],
    _a[ChainId.BSC] = [
        { address: '0x9333C74BDd1E118634fE5664ACA7a9710b108Bab', protocol: 'OKX DEX router' },
        { address: '0x2c34A2Fb1d0b4f55de51E1d0bDEfaDDce6b7cDD6', protocol: 'OKX Token approval' },
        { address: '0x89b8AA89FDd0507a99d334CBe3C808fAFC7d850E', protocol: 'Odos aggregator router' },
        {
            address: '0x6131B5fae19EA4f9D964eAc0408E4408b66337b5',
            protocol: 'Kyberswap aggregator router',
        },
    ],
    _a[ChainId.ARBITRUM] = [
        { address: '0xf332761c673b59B21fF6dfa8adA44d78c12dEF09', protocol: 'OKX DEX router' },
        { address: '0x70cBb871E8f30Fc8Ce23609E9E0Ea87B6b222F58', protocol: 'OKX Token approval' },
        { address: '0xa669e7A0d3b3e4Fa48af2dE86BD4CD7126Be4e13', protocol: 'Odos aggregator router' },
        {
            address: '0x6131B5fae19EA4f9D964eAc0408E4408b66337b5',
            protocol: 'Kyberswap aggregator router',
        },
    ],
    _a[ChainId.POLYGON] = [
        { address: '0xA748D6573acA135aF68F2635BE60CB80278bd855', protocol: 'OKX DEX router' },
        { address: '0x3B86917369B83a6892f553609F3c2F439C184e31', protocol: 'OKX Token approval' },
        { address: '0x4E3288c9ca110bCC82bf38F09A7b425c095d92Bf', protocol: 'Odos aggregator router' },
        {
            address: '0x6131B5fae19EA4f9D964eAc0408E4408b66337b5',
            protocol: 'Kyberswap aggregator router',
        },
    ],
    _a[ChainId.OPTIMISM] = [
        { address: '0xf332761c673b59B21fF6dfa8adA44d78c12dEF09', protocol: 'OKX DEX router' },
        { address: '0x68D6B739D2020067D1e2F713b999dA97E4d54812', protocol: 'OKX Token approval' },
        { address: '0xCa423977156BB05b13A2BA3b76Bc5419E2fE9680', protocol: 'Odos aggregator router' },
        {
            address: '0x6131B5fae19EA4f9D964eAc0408E4408b66337b5',
            protocol: 'Kyberswap aggregator router',
        },
    ],
    _a[ChainId.AVALANCHE] = [
        { address: '0x1daC23e41Fc8ce857E86fD8C1AE5b6121C67D96d', protocol: 'OKX DEX router' },
        { address: '0x40aA958dd87FC8305b97f2BA922CDdCa374bcD7f', protocol: 'OKX Token approval' },
        { address: '0x88de50B233052e4Fb783d4F6db78Cc34fEa3e9FC', protocol: 'Odos aggregator router' },
        {
            address: '0x6131B5fae19EA4f9D964eAc0408E4408b66337b5',
            protocol: 'Kyberswap aggregator router',
        },
    ],
    _a[ChainId.BASE] = [
        { address: '0x6b2C0c7be2048Daa9b5527982C29f48062B34D58', protocol: 'OKX DEX router' },
        { address: '0x57df6092665eb6058DE53939612413ff4B09114E', protocol: 'OKX Token approval' },
        { address: '0x19cEeAd7105607Cd444F5ad10dd51356436095a1', protocol: 'Odos aggregator router' },
        {
            address: '0x6131B5fae19EA4f9D964eAc0408E4408b66337b5',
            protocol: 'Kyberswap aggregator router',
        },
    ],
    _a);
export var NETWORK_LOGOS = (_b = {},
    _b[ChainId.ETHEREUM] = '/static/geniusImages/network_logos/ethereum.png',
    _b[ChainId.SOLANA] = '/static/geniusImages/network_logos/solana.png',
    _b[ChainId.BSC] = '/static/geniusImages/network_logos/binance.png',
    _b[ChainId.POLYGON] = '/static/geniusImages/network_logos/polygon.png',
    _b[ChainId.AVALANCHE] = '/static/geniusImages/network_logos/avalanche.svg',
    _b[ChainId.ARBITRUM] = '/static/geniusImages/network_logos/arbitrum.png',
    _b[ChainId.OPTIMISM] = '/static/geniusImages/network_logos/optimism.png',
    _b[ChainId.BASE] = '/static/geniusImages/network_logos/base.svg',
    _b[ChainId.BLAST] = '/static/geniusImages/network_logos/blast.svg',
    _b);
export var ACTIVE_NETWORKS = Object.values(ChainId)
    .filter(function (chainId) {
    return chainId !== ChainId.UNKNOWN &&
        chainId !== ChainId.SOLANA_DLN &&
        chainId !== ChainId.SOLANA_OKX &&
        chainId !== ChainId.BLAST &&
        chainId !== ChainId.SUI;
})
    .map(function (chainId) { return parseInt(chainId.toString()); })
    .filter(function (chainId) { return !isNaN(chainId); });
export var ACTIVE_EVM_NETWORKS = ACTIVE_NETWORKS.filter(function (chainId) { return chainId !== ChainId.SOLANA; });
//these are multiplied by the multiplier
export var minGasUsdValuePerChain = (_c = {},
    _c[ChainId.ARBITRUM] = 1,
    _c[ChainId.OPTIMISM] = 1,
    _c[ChainId.POLYGON] = 1,
    _c[ChainId.BSC] = 1,
    _c[ChainId.AVALANCHE] = 1,
    _c[ChainId.BLAST] = 0.4,
    _c[ChainId.BASE] = 1,
    _c[ChainId.ETHEREUM] = 10,
    _c);
export var refillGasAmounts = (_d = {},
    _d[ChainId.ARBITRUM] = 0.75,
    _d[ChainId.OPTIMISM] = 0.5,
    _d[ChainId.POLYGON] = 0.5,
    _d[ChainId.BSC] = 1,
    _d[ChainId.AVALANCHE] = 1,
    _d[ChainId.BLAST] = 0.5,
    _d[ChainId.BASE] = 0.5,
    _d[ChainId.ETHEREUM] = 10,
    _d);
export var GasSetting;
(function (GasSetting) {
    GasSetting[GasSetting["MARKET"] = 1] = "MARKET";
    GasSetting[GasSetting["CASUAL"] = 1.2] = "CASUAL";
    GasSetting[GasSetting["RAPID"] = 1.5] = "RAPID";
    GasSetting[GasSetting["NITRO"] = 2] = "NITRO";
})(GasSetting || (GasSetting = {}));
export var SolanaPriorityFee;
(function (SolanaPriorityFee) {
    SolanaPriorityFee[SolanaPriorityFee["BASE"] = 1500000] = "BASE";
    SolanaPriorityFee[SolanaPriorityFee["MEDIUM"] = 7500000] = "MEDIUM";
    SolanaPriorityFee[SolanaPriorityFee["HIGH"] = 15000000] = "HIGH";
})(SolanaPriorityFee || (SolanaPriorityFee = {}));
export var HasEIP1559Support = new Map([
    // [ChainId.ETHEREUM, false],
    [ChainId.AVALANCHE, false],
    // [ChainId.SEPOLIA, false],
    [ChainId.POLYGON, false],
    // [ChainId.FANTOM, false],
    // [ChainId.MANTLE, false],
    // [ChainId.MANTA, false],
    [ChainId.ARBITRUM, false],
    [ChainId.OPTIMISM, false],
    [ChainId.BSC, false],
    [ChainId.BLAST, false],
    // [ChainId.METIS, false],
    [ChainId.BASE, false],
    // [ChainId.SOLANA, false],
]);
export var GasSettingValues = new Map([
    [GasSetting.MARKET, { baseMultiplier: 1, maxPriorityFee: parseGwei('1') }],
    [GasSetting.CASUAL, { baseMultiplier: 1.5, maxPriorityFee: parseGwei('2') }],
    [GasSetting.RAPID, { baseMultiplier: 2, maxPriorityFee: parseGwei('5') }],
    [GasSetting.NITRO, { baseMultiplier: 3, maxPriorityFee: parseGwei('10') }],
]);
export var TRUST_WALLET_SLUGS = (_e = {},
    _e[ChainId.ETHEREUM] = 'ethereum',
    _e[ChainId.BSC] = 'binance',
    _e[ChainId.AVALANCHE] = 'avalanchec',
    // [ChainId.FANTOM]: "fantom",
    _e[ChainId.POLYGON] = 'polygon',
    // [ChainId.MANTLE]: 'mantle',
    // [ChainId.METIS]: 'metis',
    // [ChainId.MANTA]: 'manta',
    _e[ChainId.BASE] = 'base',
    _e[ChainId.BLAST] = 'blast',
    _e[ChainId.ARBITRUM] = 'arbitrum',
    _e[ChainId.OPTIMISM] = 'optimism',
    _e);
export var DEX_SCREENER_SLUGS = (_f = {},
    _f[ChainId.ETHEREUM] = 'ethereum',
    _f[ChainId.BSC] = 'bsc',
    _f[ChainId.AVALANCHE] = 'avalanche',
    // [ChainId.FANTOM]: "fantom",
    _f[ChainId.POLYGON] = 'polygon',
    // [ChainId.MANTLE]: 'mantle',
    // [ChainId.METIS]: 'metis',
    // [ChainId.MANTA]: 'manta',
    _f[ChainId.BASE] = 'base',
    _f[ChainId.BLAST] = 'blast',
    _f[ChainId.ARBITRUM] = 'arbitrum',
    _f[ChainId.OPTIMISM] = 'optimism',
    _f[ChainId.SOLANA] = 'solana',
    _f[ChainId.SOLANA_DLN] = 'solana',
    _f);
export var SOLANA_TIP_ACCOUNTS = [
    '96gYZGLnJYVFmbjzopPSU6QiEV5fGqZNyN9nmNhvrZU5',
    'HFqU5x63VTqvQss8hp11i4wVV8bD44PvwucfZ2bU7gRe',
    'Cw8CFyM9FkoMi7K7Crf6HNQqf4uEMzpKw6QNghXLvLkY',
    'ADaUMid9yfUytqMBgopwjb2DTLSokTSzL1zt6iGPaS49',
    'DfXygSm4jCyNCybVYYK6DwvWqjKee8pbDmJGcLWNDXjh',
    'ADuUkR4vqLUMWXxW9gh6D6L8pMSawimctcNZ5pGwDcEt',
    'DttWaMuVvTiduZRnguLF7jNxTgiMBZ1hyAumKUiL2KRL',
    '3AVi9Tg9Uo68tJfuvoKvqKNWKkC5wPdSSdeBnizKZ6jT',
];
export var PUBLIC_RPCS = (_g = {},
    _g[ChainId.ETHEREUM] = 'https://thrumming-multi-arm.quiknode.pro/5ea2c67d3b58c2c1cee6e6a6f43b94a1975b1980/',
    _g[ChainId.BSC] = 'https://dry-methodical-hill.bsc.quiknode.pro/d8aadcca1bc431a6f9431867d1e791e79cb2dc5a/',
    _g[ChainId.AVALANCHE] = 'https://muddy-little-ensemble.avalanche-mainnet.quiknode.pro/ed210caceb574d7be33ec015c7c96cfe6018ea1d/ext/bc/C/rpc/',
    // [ChainId.FANTOM]: "https://falling-yolo-sponge.fantom.quiknode.pro/ba5f50fb7386ee1b11e618fc9b44a1e136d48662/",
    _g[ChainId.POLYGON] = 'https://boldest-frequent-shard.matic.quiknode.pro/9ed72dc07c8d6d03aa38cb8ab50324a9df7c6066/',
    //  [ChainId.MANTLE]: 'mantle',
    //  [ChainId.METIS]: 'metis',
    //  [ChainId.MANTA]: 'manta',
    _g[ChainId.BASE] = 'https://quaint-damp-night.base-mainnet.quiknode.pro/bc2f10f8075cb664278c3a4d90442c78d933e8ae/',
    _g[ChainId.BLAST] = 'https://smart-wild-pine.blast-mainnet.quiknode.pro/9646d0e69112fbbd4f3867e63acfd6b4b4eae40f/',
    _g[ChainId.ARBITRUM] = 'https://multi-sly-choice.arbitrum-mainnet.quiknode.pro/00512554e4c166d36970f60acd56e1168f7be8ab/',
    _g[ChainId.OPTIMISM] = 'https://quaint-cool-lambo.optimism.quiknode.pro/9a1d1a573c3980c1cb94030c8e5c453547781f93/',
    _g[ChainId.SOLANA] = 'https://thrumming-evocative-arrow.solana-mainnet.quiknode.pro/b95508bd97189273edee98f183d296d43bd7f4f0/',
    _g[ChainId.SUI] = 'https://sui-rpc.publicnode.com',
    _g);
export var GASTANK_DEPLOYMENTS = (_h = {},
    _h[ChainId.ETHEREUM] = '0x1650E627A82bBC89AB1E06126E0B581985a281D9',
    _h[ChainId.AVALANCHE] = '0x3dA2B1f53c986b0CFaC0859522a26346194099C8',
    _h[ChainId.ARBITRUM] = '0xe4Be58011D84af78D89361BB2e42f3443764278C',
    _h[ChainId.BASE] = '0x47E2919A2A74240DDE39A572c2b1F7670F3e098E',
    _h[ChainId.OPTIMISM] = '0x0C7877388B897632F7D843C634D761Fd59b2151D',
    _h[ChainId.POLYGON] = '0x4c542aA81Df4CA58A20e79c716045Be9D65994F9',
    _h[ChainId.BSC] = '0x47cD7241bA46995a17274Dea5ED4F61e7e843dEa',
    _h);
export var MULTICALL_DEPLOYMENTS = (_j = {},
    _j[ChainId.ETHEREUM] = '0x7B29feB9F3DE3D62dF3B4047F69C495cbFf03180',
    _j[ChainId.AVALANCHE] = '0x7A33A037538F1CD41036287472f1Dbdb86Ed3E7e',
    _j[ChainId.ARBITRUM] = '0xf5fD222d0Feb145fadce4f47Bd7bA96100DAA04C',
    _j[ChainId.BASE] = '0x8001b576A563D4D3b33bB936FF9e5022ab8aFc5e',
    _j[ChainId.OPTIMISM] = '0x2a2d18179721e4F67aC2f417259eDd9239196b62',
    _j[ChainId.POLYGON] = '0x5EaDf63cA8834d64e6ad97b379DC6215f92BFc03',
    _j[ChainId.BSC] = '0x07163134f1d32358169F46ae98C7d5bA6242fBAE',
    _j);
export var PROXY_DEPLOYMENTS = (_k = {},
    _k[ChainId.ETHEREUM] = '0x4c542aA81Df4CA58A20e79c716045Be9D65994F9',
    _k[ChainId.AVALANCHE] = '0x845D9fAb2F1145C5a90E4793449d0aA358ac010C',
    _k[ChainId.ARBITRUM] = '0xd018745cD4A50Ed7B3d0f5ec6C36D475023C8506',
    _k[ChainId.BASE] = '0x7bF754d8632168412Bd8a25a1680757FD5727eCb',
    _k[ChainId.OPTIMISM] = '0x13e1E3846FD2096AC45943eFF6bEA6295aFff3Ac',
    _k[ChainId.POLYGON] = '0x90A7e0E1F2e97d8a4C558C6e47b3228517d0bED5',
    _k[ChainId.BSC] = '0x7365CE0CbdBfB9D510FB06cE8155a3229F46811F',
    _k);
